export const TRAINER_CARD_WIDTH = 240
